import { render, staticRenderFns } from "./AttendanceAlert.vue?vue&type=template&id=30be8254&scoped=true&"
import script from "./AttendanceAlert.vue?vue&type=script&lang=js&"
export * from "./AttendanceAlert.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceAlert.vue?vue&type=style&index=0&id=30be8254&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30be8254",
  null
  
)

export default component.exports